var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiRequest, withDefaultHeaders } from "../../../lib";
import { getSmpAsDatafanHeaders } from "./smp_headers";
import { getSmpAsDatafanToken, refreshSmpAsDatafanToken } from "./smp_token";
const apiRequestWithSmpHeaders = withDefaultHeaders(getSmpAsDatafanHeaders, apiRequest);
export const apiSmpHandleTokenRefresh = (requestFunc) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield requestFunc();
    }
    catch (clause) {
        const failureApi = clause;
        if (failureApi.code !== "API__INTERNAL__403_FORBIDDEN" &&
            failureApi.code !== "API__INTERNAL__401_UNAUTHORIZED") {
            throw failureApi;
        }
        yield refreshSmpAsDatafanToken();
        return requestFunc();
    }
});
export const apiRequestSmpAsDatafan = (requestParams, errorToFailureHash) => __awaiter(void 0, void 0, void 0, function* () {
    if (!getSmpAsDatafanToken()) {
        yield refreshSmpAsDatafanToken();
    }
    return apiSmpHandleTokenRefresh(() => apiRequestWithSmpHeaders(requestParams, errorToFailureHash));
});
//# sourceMappingURL=smp_request.js.map